import React from 'react'

import Image from 'next/image'
import { LinearProgress } from '@mui/material'
import NoSsr from '@mui/material/NoSsr'
import PharmeDesktopImage from '../public/images/logo/logo_desktop.png'
import CosStoreLogoImg from '../public/images/groupement/cos/logo.png'
import OfficapLogoImg from '../public/images/groupement/officap/logo.png'
import AeliaLogoImg from '../public/images/groupement/aelia/logo.png'
import CentraleMediprixLogoImg from '../public/images/groupement/centraleMediprix/logo.png'
import PharmacologyStoreLogoImg from '../public/images/groupement/pharmacologyStore/logo.png'
import CentraleDpharmaLogoImg from '../public/images/groupement/centraleDpharma/logo.png'
import OutremerLogoImg from '../public/images/groupement/outremer/logo.png'
import HelloPharmacieLogoImg from '../public/images/groupement/helloPharmacie/logo.png'
import NormandiePharmaLogoImg from '../public/images/groupement/normandiePharma/logo.png'
import TrenteSeptDegresLogoImg from '../public/images/groupement/37degres/logo.png'
import { urlSiteGroupement } from '@/lib/urlSiteGroupement'

const MainLoader = () => {
  const {
    siteCos,
    siteLesOfficinales,
    siteAeliaStore,
    siteCentraleMediprix,
    sitePharmacologyStore,
    siteCentraleDpharma,
    siteOutremer,
    siteHelloPharmacie,
    siteNormandiePharma,
    site37Degres,
  } = urlSiteGroupement()
  return (
    <NoSsr>
      <div className="w-full my-16 text-center">
        <Image
          src={
            siteOutremer
              ? PharmeDesktopImage
              : siteAeliaStore
                ? AeliaLogoImg
                : siteLesOfficinales
                  ? OfficapLogoImg
                  : siteCos
                    ? CosStoreLogoImg
                    : siteCentraleMediprix
                      ? CentraleMediprixLogoImg
                      : sitePharmacologyStore
                        ? PharmacologyStoreLogoImg
                        : siteCentraleDpharma
                          ? CentraleDpharmaLogoImg
                          : siteHelloPharmacie
                            ? HelloPharmacieLogoImg
                            : siteNormandiePharma
                              ? NormandiePharmaLogoImg
                              : site37Degres
                                ? TrenteSeptDegresLogoImg
                                : PharmeDesktopImage
          }
          width={261}
          height={61}
          alt={'loading'}
        />
        <LinearProgress style={{ width: 150, margin: '0 auto' }} />
        <div>
          {typeof t === 'function' ? t({ id: 'web_pms_loading' }) : 'Chargement en cours ...'}
        </div>
      </div>
    </NoSsr>
  )
}

export default MainLoader
